<template>
  <div>
    <Panel :data="chronotachographHistory"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import Panel from '../Panel.vue'
import { mapMutations } from 'vuex'

export default {
  components: { Panel },
  computed: {
    chronotachographHistory() {
      return this.getModel
    },
  },
  created() {
    this.asyncTemplateShow(this.id, {
      after: ({model}) => this.setNameBreadcrumb(model.id)
    })
  },
  data: () => ({
    modelPathPrefix: 'admin/maestro',
    nameModel: 'ChronotachographHistory',
  }),
  methods: {
    ...mapMutations(['setNameBreadcrumb']),
  },
  mixins: [ModelMapper],
  name: 'Show',
  props: {
    id: { required: false }
  }
}

</script>

<style scoped>

</style>